import { Component, OnInit, Inject } from '@angular/core';
import { AdminService } from '../../services/admin.service';
import { NgForm } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericDialogData } from '../../models/generic.dialog.interface';
import { AbstractBiditComponent } from '../../../shared/controls/abstract.bidit.component';
import { ItemFilter } from '../../models/item.filter';
import { DeviceDetectorService } from 'ngx-device-detector';

import { IdiItemSource } from '../../../shared/models/idiitem.source.interface';
import { IdiAreaSource } from '../../../shared/models/Idiarea.source.interface';
import { IdiAccessoryItem } from '../../../shared/models/idiitem.accessory.interface';

@Component({
  selector: 'app-edit-area-source',
  templateUrl: './area.source.edit.component.html',
  styleUrls: ['./area.source.edit.component.scss']
})
export class AreaSourceEditComponent extends AbstractBiditComponent implements OnInit {

  constructor(private adminService: AdminService, deviceDetectorService: DeviceDetectorService,
    public areaDialogRef: MatDialogRef<AreaSourceEditComponent>, @Inject(MAT_DIALOG_DATA) public data: GenericDialogData) {
    super(deviceDetectorService);
  }

  area: IdiAreaSource;
  areaAccessories: IdiAccessoryItem[];
  selectedAreaAccessories: number[] = [];
  idiAccessoryItems: IdiItemSource[];

  errors: string;

  itemFilter: ItemFilter;

  ngOnInit() {
    let areaId: number = this.data.id;
    let dealerId = this.adminService.getDealerId();
    this.itemFilter = {} as ItemFilter;

    if (dealerId != null) return;

    if (areaId == null) {
      this.area = {} as IdiAreaSource;
      this.area.area_IsActive = true;
    }
    else {
      this.adminService.getIDIArea(areaId)
        .subscribe({
          next: (data) => {
            this.area = data;
            this.selectedAreaAccessories = data.itemAreas.map(ia => ia.item_ID);
          }
        })
    }

    this.adminService.searchIDIItemList(this.itemFilter)
      .subscribe({
        next: (data) => {
          this.idiAccessoryItems = data.filter(i => i.itemType?.itemType_IsAccessory);
        }
      })
  }

  saveArea(form: NgForm) {
    console.log('in areasource onSubmit: ', this.area);

    this.errors = '';
    if (form.valid) {
      this.isRequesting = true;

      this.adminService.saveIDIArea(this.area)
        .pipe(finalize(() => this.isRequesting = false))
        .subscribe({
          next: (result) => {
          this.saveAreaAccessories(result);
        },
          error: (error: string) => {
            this.onError(error);
          },
          complete: () => {
            this.isRequesting = false;
          }
        });
    }
  }

  saveAreaAccessories(areaId: number) {
    console.log('in saveAreaAccessories - area: ' + areaId);
    this.errors = '';

    this.adminService.saveIDIAreaAccessories(areaId, this.selectedAreaAccessories)
      .pipe(finalize(() => this.isRequesting = false))
      .subscribe({
          next: (result) => {
          this.areaDialogRef.close(result);
        },
        error: (error: string) => {
          this.onError(error);
        },
        complete: () => {
          this.isRequesting = false;
        }
      });
  }

  onNoClick(): void {
    this.areaDialogRef.close();
  }

}
